const config = {
    BASE_URL: 'https://app.leadssea.com:5000/api',
  };
  
  export default config;
  